import { useEffect, useState } from 'react';
import {
  Alert,
  AlertTitle,
  Container,
  Grid,
  InputAdornment,
  Link,
  Skeleton,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import PhoneInTalkOutlinedIcon from '@mui/icons-material/PhoneInTalkOutlined';

import distributorApi from '../../api/distributorApi';
import ProductCard from '../../sections/client/products/ProductCard';

// Telefonos de contacto que se muestran solo a los distribuidores (aviso de esta pagina).
const DISTRIBUTOR_PHONES = ['901 986 801', '934 728 864', '912 359 288'];

// Lista de precios exclusiva del rol distribuidor: mismos productos que la tienda, con precios
// propios mostrados solo en soles (con el tipo de cambio del distribuidor). Es solo de consulta:
// sin carrito ni compra por WhatsApp, y el distribuidor no puede salir de esta pagina (ver
// ClientLayout).
export default function DistributorCatalogPage() {
  const [searchInput, setSearchInput] = useState('');
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoading(true);
    setError(false);

    const timeout = setTimeout(async () => {
      try {
        const { data } = await distributorApi.getDistributorProducts({ search: searchInput || undefined, per_page: 50 });
        setProducts(data.data);
      } catch (err) {
        setError(true);
      } finally {
        setLoading(false);
      }
    }, 300);

    return () => clearTimeout(timeout);
  }, [searchInput]);

  return (
    <Container maxWidth="lg" sx={{ py: 5 }}>
      <Stack spacing={1} sx={{ mb: 4 }}>
        <Typography variant="h4">Lista de precios distribuidor</Typography>
        <Typography color="text.secondary">Precios de venta en soles para tu cuenta de distribuidor.</Typography>
      </Stack>

      <Alert severity="info" icon={<PhoneInTalkOutlinedIcon />} sx={{ mb: 3 }}>
        <AlertTitle>Contáctanos</AlertTitle>
        {DISTRIBUTOR_PHONES.map((phone, index) => (
          <span key={phone}>
            {index > 0 && ' - '}
            <Link href={`tel:${phone.replace(/\s/g, '')}`} color="inherit" sx={{ fontWeight: 600 }}>
              {phone}
            </Link>
          </span>
        ))}
      </Alert>

      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mb: 4 }}>
        <TextField
          fullWidth
          label="Buscar producto"
          placeholder="Buscar por nombre"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            },
          }}
        />
      </Stack>

      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          No se pudo cargar la lista de precios. Intenta nuevamente.
        </Alert>
      )}

      {!loading && !error && products.length === 0 && (
        <Alert severity="info">No encontramos productos con ese criterio.</Alert>
      )}

      <Grid container spacing={3}>
        {loading
          ? Array.from({ length: 8 }).map((_, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <Grid key={index} size={{ xs: 12, sm: 6, md: 3 }}>
                <Skeleton variant="rounded" height={220} />
              </Grid>
            ))
          : products.map((product) => (
              <Grid key={product.id} size={{ xs: 12, sm: 6, md: 3 }}>
                <ProductCard product={product} currency="PEN" readOnly />
              </Grid>
            ))}
      </Grid>
    </Container>
  );
}
